import { apiGet, apiPost, apiPut, apiDelete } from '../utils/axios';

const baseUrl = '/forum';

export const addPost = (data) => {
  return apiPost(`${baseUrl}/posts`, data);
};

export const updatePost = ({ id, ...payload }) => {
  return apiPut(`${baseUrl}/post/${id}`, payload);
};

export const deletePost = (id, data) => {
  return apiDelete(`${baseUrl}/post/${id}`, data);
};

export const getForum = (id, q) => {
  return apiGet(`${baseUrl}/${id}?query=${q}`);
};
